
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/content-migrations/backbone/views/subviews/ImportBlueprintSettingsView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return " disabled ";
  }

function program3(depth0,data) {
  
  
  return " style=\"opacity: 0.6\" ";
  }

  buffer += "<div id=\"importBlueprintSettingsContainer\" style=\"display: inline-block\" data-tooltip='{\"position\":\"top\"}' title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("content_migrations.subviews.import_blueprint_settings")
  },data:data},helper ? helper.call(depth0, "you_do_not_have_blueprint_course_management_permis_51ae6ef5", "You do not have Blueprint Course management permissions", options) : helperMissing.call(depth0, "t", "you_do_not_have_blueprint_course_management_permis_51ae6ef5", "You do not have Blueprint Course management permissions", options)))
    + "\">\n  <label class=\"checkbox\">\n    <input type=\"checkbox\" ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.SHOW_BP_SETTINGS_IMPORT_OPTION), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " id=\"importBlueprintSettingsCheckbox\">\n    <span ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.SHOW_BP_SETTINGS_IMPORT_OPTION), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.import_blueprint_settings")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.import_blueprint_settings.checkbox_label", "Import Blueprint Course settings", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.import_blueprint_settings.checkbox_label", "Import Blueprint Course settings", options)))
    + "\n    </span>\n  </label>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  